<nz-spin [nzSpinning]="this.isButtonLoading">
  <h4 class="mb-3">{{ 'shared.exportContent.title' | transloco }}</h4>
  <form nz-form [formGroup]="exportForm">
    <div class="grid grid-cols-2 gap-5">
      <div>
        <!-- General -->
        <h5 class="mb-2">{{ 'shared.exportContent.sections.general' | transloco }}</h5>

        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="gen_DisplayMap">{{ 'shared.exportContent.general.showMap' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="gen_ItineraryBannerImage">{{ 'shared.exportContent.general.itineraryBannerImage' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="gen_SummaryTable">{{ 'shared.exportContent.general.summaryTable' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="itineraryTitleBoxChecked"
            >{{ 'shared.exportContent.general.hideItineraryTitle' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="remarksTipsBoxChecked"
            >{{ 'shared.exportContent.general.hideDayFeaturedTipsRemarks' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="additionalNotesBoxChecked"
            >{{ 'shared.exportContent.general.hideTourWiseAdditionalNotes' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="paymentLinkBoxChecked"
            >{{ 'shared.exportContent.general.hidePaymentLink' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="websiteLinkBoxChecked"
            >{{ 'shared.exportContent.general.hideWebsiteLink' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="displayMapTopsideBoxChecked"
            >{{ 'shared.exportContent.general.displayMapOnTop' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="thumbnailBoxChecked"
            >{{ 'shared.exportContent.general.hideDayThumbnails' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="hideDaywiseInclusionsExclusionsBoxChecked"
            >{{ 'shared.exportContent.general.hideDaywiseInclusionsExclusions' | transloco }}</label>
          </div>
        </div>
      <div>
        <!-- Accommodation -->
        <h5 class="mb-2">{{ 'shared.exportContent.sections.accommodation' | transloco }}</h5>

          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="hotelRatingBoxChecked"
            >{{ 'shared.exportContent.accommodation.hideHotelStarRatings' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.accommodationNoteBoxChecked"
            >{{ 'shared.exportContent.accommodation.hideNotes' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="hotelDescriptionBoxChecked"
            >{{ 'shared.exportContent.accommodation.hideDescription' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="hotelWebsiteBoxChecked"
            >{{ 'shared.exportContent.accommodation.hideWebsiteLink' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="hotelImageBoxChecked"
            >{{ 'shared.exportContent.accommodation.hideHotelImage' | transloco }}</label>
          </div>
        <div>
          <label
            class="mb-1"
            nz-checkbox
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="accommodationRoomsBoxChecked"
          >{{ 'shared.exportContent.accommodation.hideRooms' | transloco }}</label>
        </div>

      </div>
      <div>
        <!-- Destination -->
        <h5 class="mb-2">{{ 'shared.exportContent.sections.destination' | transloco }}</h5>
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="dest_Description">{{ 'shared.exportContent.destination.description' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="dest_Image">{{ 'shared.exportContent.destination.image' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div>
        <!-- Transport -->
        <h5 class="mb-2">{{ 'shared.exportContent.sections.transport' | transloco }}</h5>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="mileageBoxChecked"
            >{{ 'shared.exportContent.transport.hideMileage' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.transportNoteBoxChecked"
            >{{ 'shared.exportContent.transport.hideNotes' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="travelTimeBoxChecked"
            >{{ 'shared.exportContent.transport.hideTravelTime' | transloco }}</label>
          </div>

          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="vehicleNameBoxChecked"
            >{{ 'shared.exportContent.transport.hideVehicleName' | transloco }}</label>
          </div>

          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="vehicleImageBoxChecked"
            >{{ 'shared.exportContent.transport.hideVehicleImage' | transloco }}</label>
          </div>
        </div>
      <div>
        <!-- Experiences -->
        <h5 class="mb-2">{{ 'shared.exportContent.sections.experiences' | transloco }}</h5>
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="exp_Image">{{ 'shared.exportContent.experiences.image' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="exp_Description">{{ 'shared.exportContent.experiences.description' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.experiencesNoteBoxChecked"
            >{{ 'shared.exportContent.experiences.hideNotes' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.includeBadgeBoxChecked"
            >{{ 'shared.exportContent.experiences.hideIncludedBadge' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.excludeBadgeBoxChecked"
            >{{ 'shared.exportContent.experiences.hideExcludedBadge' | transloco }}</label>
          </div>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.hideExperiencesTimesBoxChecked"
            >{{ 'shared.exportContent.experiences.hideExperiencesTimes' | transloco }}</label>
          </div>
      </div>

      <div>
        <h5 class="mb-2">{{ 'shared.exportContent.sections.costing' | transloco }}</h5>
          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="costingBoxChecked"
            >{{ 'shared.exportContent.costing.hideCosting' | transloco }}</label>
          </div>

          <div>
            <label
              class="mb-1"
              nz-checkbox
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="this.pricingRemarksBoxChecked"
            >{{ 'shared.exportContent.costing.hideSpecialNotes' | transloco }}</label>
          </div>
      </div>
      <div>
        <h5 class="mb-2">{{ 'shared.exportContent.sections.mapOptions' | transloco }}</h5>
      <div class="grid grid-cols-2">
        <div>
          <nz-radio-group [ngModelOptions]="{standalone: true}" [(ngModel)]="this.mapType">
            <label *ngFor="let map of mapTypeOptions"  nz-radio [nzValue]="map.value">{{map.label}}</label>
          </nz-radio-group>
        </div>
      </div>
      </div>
      <div>
        <h5 class="mb-2">{{ 'shared.exportContent.sections.theme' | transloco }}</h5>
        <nz-radio-group [ngModelOptions]="{standalone: true}" [(ngModel)]="this.currentThemeType">
          <label *ngFor="let format of SETTINGS.ITINERARY_THEME_TYPES" nz-radio [nzValue]="format.value">
            {{ format.label }}
          </label>
        </nz-radio-group>
      </div>
      <!-- <div>
        <h5 class="mb-2">Export Format</h5>
        <nz-radio-group formControlName="exportFormat">
          <label *ngFor="let format of exportFormats" nz-radio [nzValue]="format.value">
            {{ format.label }}
          </label>
        </nz-radio-group>
      </div> -->
    </div>
  </form>
</nz-spin>


<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'shared.exportContent.footer.close' | transloco }}</button>
  <button nz-button nzType="primary" [nzLoading]="this.isButtonLoading" (click)="this.generatePDF()">
    {{ 'shared.exportContent.footer.export' | transloco }}
  </button>
</div>
